"use client";

import { setCookieHasRefreshToken } from "../../../lib";
import { useRequestMutation } from "../../../request";
import { useSession } from "../../../session";
import { registerSchema } from "./types";

export const useRequestRegister = () => {
  const { setStatus } = useSession();

  return {
    mutationPostEmailPassword: useRequestMutation({
      mutationFnRequestProps: (data: { email: string; password: string }) => ({
        body: JSON.stringify(data),
        requestType: "default",
        schema: registerSchema,
        urlBackendPath: "/register",
      }),
      onSuccess: () => {
        setCookieHasRefreshToken({ value: true });
        setStatus("authenticated");
      },
    }),
  };
};
